import { render, staticRenderFns } from "./UploadAudio.vue?vue&type=template&id=530193fc&scoped=true"
import script from "./UploadAudio.vue?vue&type=script&lang=js"
export * from "./UploadAudio.vue?vue&type=script&lang=js"
import style0 from "./UploadAudio.vue?vue&type=style&index=0&id=530193fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530193fc",
  null
  
)

export default component.exports